import {AbstractControl} from '@angular/forms';
import {Base, BaseDTO} from './base';

export interface NotificationsFilters {
    tenant_id?: number;
    onlyCurrentTenant?: boolean;
    title?: string;
}

export interface NotificationsDTO extends BaseDTO {
    id?: number,
    sent_at?: string,
    title: string,
    body: string,
    tenant_id: number
}

export class Notifications extends Base {
    sent_at?: Date;
    title: string;
    body: string;
    tenant_id: number;

    constructor(source: NotificationsDTO){
        super(source);
        if(source){
            this.sent_at = source.sent_at ? new Date(source.sent_at) : undefined;
            this.title = source.title;
            this.body = source.body;
            this.tenant_id = source.tenant_id;
        }
    }

    toDTO(): NotificationsDTO {
        return {
            ...super.toDTO(),
            // sent_at: this. sent_at ? this.sent_at.toISOString() : undefined,
            sent_at: this.sent_at instanceof Date && !isNaN(this.sent_at.getTime()) ? this.sent_at.toISOString() : undefined,
            title: this.title,
            body: this.body,
            tenant_id: this.tenant_id,
        };
    }

    static fromFormGroup(formGroup: AbstractControl, original?: Notifications){
        const formModel = formGroup.value;
        let notifications = new Notifications(null);

        notifications.sent_at = original?.sent_at ?? new Date();
        notifications.title = formModel.title;
        notifications.body = formModel.body;
        notifications.tenant_id = formModel.tenant_id;

        if(original){
            notifications.id = original.id
        }
        return notifications;
    }
}